import  { attributeTypes, componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, { getNodeComponentAttributeValue, getNodeStyleAttributeValue, setNodeComponentAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { assignDomRef, GetLocationHoverAtt, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { ResizeableType, WBComponent } from "./WBComponent";
import { GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { Fragment } from "react";
import WebDesigner from "../WebDesigner";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { FindClosestFixedHeightContainer, FixedHeightWarning } from "./FixedHeightWarning";

export default class BusinessBookNow extends WBComponent {

    constructor() {
        super();
        this.typename = wBComponentTypeNames.businessBookNow;
        this.displayName = "Book Now";
        this.dropList = defaultDropList.filter((item)=>item!=wBComponentTypeNames.grid);
        this.editList = [componentAttributeTypes.multiLocation, componentAttributeTypes.alloWMultiLocalationBooking, componentAttributeTypes.layoutId];
        this.resizeType = ResizeableType.None;
        this.primaryEditAttributes = [componentAttributeTypes.multiLocation];
        this.contentEditable = false;
        this.hideAdvancedSettings = true;
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-book" viewBox="0 0 16 16"> <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811V2.828zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z"/> </svg>
    }

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);
    }

    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {
        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, siteData.businessId);
        const atts = GetNodeDomAttributes("v-review-percentage w-full max-100 vb-control", component, screenSize, isEditor);
        let inFixedString = "";

        const layout = getNodeComponentAttributeValue(component, componentAttributeTypes.layoutId, "1");
        if (!isEditor) {
            return <BusinessPlaceHolder node={component} dataKey="book-now" layout={layout} classNames={atts.className} />
        }
        else{
            let fhnode = FindClosestFixedHeightContainer(component);
            if(fhnode){
                inFixedString = fhnode.typename;
            }
        }


        return (
            <Fragment>
                <div {...atts} {...GetLocationHoverAtt(component,siteData)}>
                    {inFixedString &&<FixedHeightWarning node={component} typename={inFixedString}/>}
                    <GenericBusinessControl key={component.id + bid} bLocationId={bid} layout={layout} dataKey="book-now" node={component} userContext={siteData} rootId={(isEditor)?"a":"b"} />
                </div>
            </Fragment>
        )
    }
}
